import React, { PureComponent, ReactNode } from 'react'
import { images } from '../../images'
import { IStoreLink } from '../../models'
import { LiteralsService } from '../../services'
import StyledSection from './styles'

interface IProps {
  label: string
  stores: IStoreLink[]
  showQrCodes?: boolean
  className?: string
}

const captionKeys = { googlePlay: 'googlePlayCaption', appStore: 'appStoreCaption' }
const storeNameKeys = { googlePlay: 'googlePlay', appStore: 'appStore' }
const qrCodeAltKeys = { googlePlay: 'qrCodeGooglePlay', appStore: 'qrCodeAppStore' }

export class AppDownload extends PureComponent<IProps> {
  private renderBadgeContent(storeLink: IStoreLink): ReactNode {
    return (
      <>
        <img className="store-icon" src={ images[storeLink.icon] } alt="" aria-hidden="true" />
        <span className="badge-text">
          <span className={ `caption ${ storeLink.store }` }>
            { LiteralsService.get(captionKeys[storeLink.store], true) }
          </span>
          <span className="store-name">{ LiteralsService.get(storeNameKeys[storeLink.store]) }</span>
        </span>
      </>
    )
  }

  private renderBadge(storeLink: IStoreLink): ReactNode {
    if (!storeLink.url) return <span className="badge">{ this.renderBadgeContent(storeLink) }</span>

    return (
      <a className="badge" href={ storeLink.url } target="_blank" rel="noopener noreferrer">
        { this.renderBadgeContent(storeLink) }
      </a>
    )
  }

  private renderStore = (storeLink: IStoreLink): ReactNode => {
    const { showQrCodes } = this.props

    return (
      <li key={ storeLink.store }>
        { showQrCodes &&
          <img
            className="qr-code"
            src={ images[storeLink.qrCode] }
            alt={ LiteralsService.get(qrCodeAltKeys[storeLink.store], true) }
          />
        }
        { this.renderBadge(storeLink) }
      </li>
    )
  }

  public render(): ReactNode {
    const { label, stores, className } = this.props

    return (
      <StyledSection className={ className }>
        <p>{ label }</p>
        <ul>{ stores.map(this.renderStore) }</ul>
      </StyledSection>
    )
  }
}
